import type { ScrapedUrlMetadata } from 'client/js/main/types/urlScraper';
import type { DataAction } from '../../../types/dataAction.type';

export const SET_QR_CODE_LINK_DATA_BASED_ON_URL_SCRAP = 'SET_QR_CODE_LINK_DATA_BASED_ON_URL_SCRAP' as const;

export const setQrCodeLinkDataBasedOnUrlScrap = (data: ScrapedUrlMetadata | undefined) => ({
  data,
  type: SET_QR_CODE_LINK_DATA_BASED_ON_URL_SCRAP,
});

export type SetQrCodeLinkDataBasedOnUrlScrapAction = DataAction<
  typeof SET_QR_CODE_LINK_DATA_BASED_ON_URL_SCRAP,
  ScrapedUrlMetadata | undefined
>;
